// searchModel.js

import URI from 'urijs';

const $keywords = $('.js-search__keywords');
const $location = $('.js-search__location');
const $discipline = $('.js-search__discipline');
const $contractType = $('.js-search__contractType');
const $orderBy = $('.js-search__orderby');
const $perPage = $('.js-search__perpage');
const $page = $('.js-search__page');
const $map = $('.js-search__map');


const Fields = (function Fields() {

	let data = {
		// form fields
		keywords : '',
		location : '',
		discipline : '',
		contractType : '',
		
		orderBy : '',
		perPage : '',
		page : '',
		map : '',

		initialLoad : true,
		results : false,
		isLoading : false
	};

	// get initial values
	getFormFieldVals();

	function getFormFieldVals() {

		if (!$keywords.length || !$location.length) {
			return false;
		}

		data.keywords = $keywords.val().trim();
		data.location = $location.val().trim();
		data.discipline = $discipline.val().trim();
		data.contractType = $contractType.val().trim();

		data.orderBy = $orderBy.val() ? $orderBy.val() : 'latest';
		data.orderBy = data.keywords ? 'relevance' : data.orderBy;

		data.perPage = $perPage.val() ? parseInt($perPage.val()) : 20;
		data.page = $page.val() ? parseInt($page.val()) : 1;
		data.map = (parseInt($map.val()) === 1) ? 1 : 0;
	}

	function get(fromSource = true) {
		fromSource && getFormFieldVals();
		return data;
	}

	function set(key, value) {
		if (key === 'keywords') $keywords.val(value);
		if (key === 'location') $location.val(value);
		if (key === 'discipline') $discipline.val(value);
		if (key === 'contractType') $contractType.val(value);
		if (key === 'orderBy') $orderBy.val(value); 
		if (key === 'perPage') $perPage.val(value);
		if (key === 'page') $page.val(value); 
		if (key === 'map') $map.val(value);
		
		// set on data prop
		data[key] = value;
		return true;
	}

	function replaceState(newData = {}) {
		for (let property in newData) {
			set(property, newData[property]);
		}
	}

	return {
		get,
		set,
		replaceState
	};

})();


// format URIs

	function buildAPIUrl(fields) {

		if (!fields) fields = Fields.get(false);

		const url = new URI(siteSettings.apiUri + 'jobs');

		for (let parameter of [
			'keywords',	'location', 'discipline', 'contractType',
			'orderBy', 'perPage', 'page'
		]) {
			let val = fields[parameter];
			if (!!val) url.setQuery(parameter, val);
		}

		if (fields.map) {
			// map searches have no pagination: request all jobs
			url.removeQuery('page');
			url.setQuery('perPage', '0');
		}

		return url;
	}


	function buildSearchPageUrl(fields) {

		if (!fields) fields = Fields.get(false);

		const url = new URI(siteSettings.searchUrl);

		for (let parameter of [
			'keywords',	'location', 'discipline', 'contractType',
			'orderBy', 'perPage', 'page',
			'map',
		]) {
			let val = fields[parameter];	
			if (!!val) url.setQuery(parameter, val);
		}

		if (fields.map) {
			// map searches have no pagination
			url.removeQuery('page');
			url.removeQuery('perPage');
		}

		return url;
	}


export default {
	Fields,
	buildAPIUrl,
	buildSearchPageUrl
}



